import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import defaultTimezone from 'Common/constants/defaultTimezone';

const createNewDate = () => utcToZonedTime(new Date(), defaultTimezone);

export default createNewDate;
